import Aura from '@primevue/themes/aura'
import PrimeVue from 'primevue/config'
import { definePreset } from '@primevue/themes'
import type { App } from 'vue'
import { primevueLocales } from './locales'
import { useSessionStore } from '@/stores/session'

// Component imports
import Avatar from 'primevue/avatar'
import Button from 'primevue/button'
import ButtonGroup from 'primevue/buttongroup'
import Card from 'primevue/card'
import Divider from 'primevue/divider'
import InputText from 'primevue/inputtext'
import Menubar from 'primevue/menubar'
import TieredMenu from 'primevue/tieredmenu'
import Panel from 'primevue/panel'
import Toolbar from 'primevue/toolbar'
import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import Tab from 'primevue/tab'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'
import InputNumber from 'primevue/inputnumber'
import InputGroupAddon from 'primevue/inputgroupaddon'
import FloatLabel from 'primevue/floatlabel'
import InputGroup from 'primevue/inputgroup'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import OverlayBadge from 'primevue/overlaybadge'
import ToastService from 'primevue/toastservice'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import Select from 'primevue/select'
import RadioButton from 'primevue/radiobutton'
import ProgressSpinner from 'primevue/progressspinner'
import Skeleton from 'primevue/skeleton'
import Checkbox from 'primevue/checkbox'
import Tag from 'primevue/tag'
import ToggleSwitch from 'primevue/toggleswitch'

import 'primeflex/primeflex.css'

const preset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{green.50}',
      100: '{green.100}',
      200: '{green.200}',
      300: '{green.300}',
      400: '{green.400}',
      500: '{green.500}',
      600: '{green.600}',
      700: '{green.700}',
      800: '{green.800}',
      900: '{green.900}',
      950: '{green.950}'
    }
  }
})

export const usePrimeVue = (app: App) => {
  const sessionStore = useSessionStore()
  const initialLocaleCode = sessionStore.getLocaleCode()
  const initialLocale = primevueLocales[initialLocaleCode] || primevueLocales.en

  app.use(PrimeVue, {
    ripple: true,
    locale: initialLocale,
    theme: {
      preset,
      options: {
        cssLayer: 'primevue',
        darkModeSelector: false
      }
    },
    pt: {
      Divider: {
        root: { style: 'height: 2px; background-color: #9A9A9A;' }
      }
    }
  })

  app.component('Button', Button)
  app.component('ButtonGroup', ButtonGroup)
  app.component('Card', Card)
  app.component('Menubar', Menubar)
  app.component('InputText', InputText)
  app.component('Avatar', Avatar)
  app.component('Panel', Panel)
  app.component('Toolbar', Toolbar)
  app.component('Divider', Divider)
  app.component('Tabs', Tabs)
  app.component('TabList', TabList)
  app.component('Tab', Tab)
  app.component('TabPanel', TabPanel)
  app.component('TabPanels', TabPanels)
  app.component('InputNumber', InputNumber)
  app.component('FloatLabel', FloatLabel)
  app.component('InputGroup', InputGroup)
  app.component('InputGroupAddon', InputGroupAddon)
  app.component('DataTable', DataTable)
  app.component('Column', Column)
  app.component('OverlayBadge', OverlayBadge)
  app.use(ToastService)
  app.component('Toast', Toast)
  app.component('Dialog', Dialog)
  app.component('Select', Select)
  app.component('RadioButton', RadioButton)
  app.component('ProgressSpinner', ProgressSpinner)
  app.component('Skeleton', Skeleton)
  app.component('Checkbox', Checkbox)
  app.component('ToggleSwitch', ToggleSwitch)
  app.component('TieredMenu', TieredMenu)
  app.component('Tag', Tag)

  return app // Shouldn't be needed, but available just in case
}
